webpackJsonp([62],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/graphql-scala-7-relations.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<p>Relations define how entities are connected with one another. You probably encountered those while working with databases.\nIn GraphQL (and Sangria) relations are strictly connected with deferred resolvers and have a similar role.\nWhen you want to find related entities, the query can be optimized and all needed data fetched at once.</p>\n<p>In other words: Relations expand Fetchers, allows for finding entities not only by their id field,\nbut also by ids quite often stored in fields of another entity.</p>\n<p>Lets try to define how many relations we have in our schema.</p>\n<p><code>User</code> has <code>links</code> and <code>votes</code> fields.</p>\n<p><code>Link</code> has <code>postedBy</code> and <code>votes</code> fields.</p>\n<p><code>Vote</code> has <code>user</code> and <code>link</code></p>\n<p>How do those relations work?\n<code>Link</code> is a main entity, first created by us and the most important. <code>Link</code> is added by a (single) user. On the other hand, a user can have more than one link.</p>\n<p><code>User</code> also can vote for a link. He can vote for a single link once, but a link can have more than one votes.</p>\n<p>So, in our app we have 3 one-to-many relations.</p>\n<h3>Preparing database</h3>\n<p>First change slightly <code>Link</code> model:</p>\n<Instruction>\n<p>Add <code>postedBy</code> field to the <code>Link</code> case class, the class should look like this:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">case</span> <span class=\"token keyword\">class</span> Link<span class=\"token punctuation\">(</span>id<span class=\"token operator\">:</span> <span class=\"token builtin\">Int</span><span class=\"token punctuation\">,</span> url<span class=\"token operator\">:</span> <span class=\"token builtin\">String</span><span class=\"token punctuation\">,</span> description<span class=\"token operator\">:</span> <span class=\"token builtin\">String</span><span class=\"token punctuation\">,</span> postedBy<span class=\"token operator\">:</span> <span class=\"token builtin\">Int</span><span class=\"token punctuation\">,</span> createdAt<span class=\"token operator\">:</span> DateTime <span class=\"token operator\">=</span> DateTime<span class=\"token punctuation\">.</span>now<span class=\"token punctuation\">)</span> <span class=\"token keyword\">extends</span> Identifiable\n</code></pre>\n      </div>\n</Instruction>\n<p>Update <code>LinksTable</code>.\n<Instruction></p>\n<p>Change the database schema. In the <code>DBSchema</code> change <code>LinksTable</code>, apply changes from the following code:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">class</span> LinksTable<span class=\"token punctuation\">(</span>tag<span class=\"token operator\">:</span> Tag<span class=\"token punctuation\">)</span> <span class=\"token keyword\">extends</span> Table<span class=\"token punctuation\">[</span>Link<span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span>tag<span class=\"token punctuation\">,</span> <span class=\"token string\">\"LINKS\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// ...</span>\n    <span class=\"token keyword\">def</span> postedBy <span class=\"token operator\">=</span> column<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"USER_ID\"</span><span class=\"token punctuation\">)</span>\n\n    <span class=\"token keyword\">def</span> <span class=\"token operator\">*</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">(</span>id<span class=\"token punctuation\">,</span> url<span class=\"token punctuation\">,</span> description<span class=\"token punctuation\">,</span> postedBy<span class=\"token punctuation\">,</span> createdAt<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>mapTo<span class=\"token punctuation\">[</span>Link<span class=\"token punctuation\">]</span>\n\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Add foreign keys.</p>\n<Instruction>\n<p>In <code>LinksTable</code> add:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">def</span> postedByFK <span class=\"token operator\">=</span> foreignKey<span class=\"token punctuation\">(</span><span class=\"token string\">\"postedBy_FK\"</span><span class=\"token punctuation\">,</span> postedBy<span class=\"token punctuation\">,</span> Users<span class=\"token punctuation\">)</span><span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p><code>Votes</code> model already has proper fields for storing external ids, we only have to add foreign keys in database setup.</p>\n<Instruction>\n<p>In <code>VotesTable</code> add:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code>  <span class=\"token keyword\">def</span> userFK <span class=\"token operator\">=</span> foreignKey<span class=\"token punctuation\">(</span><span class=\"token string\">\"user_FK\"</span><span class=\"token punctuation\">,</span> userId<span class=\"token punctuation\">,</span> Users<span class=\"token punctuation\">)</span><span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">def</span> linkFK <span class=\"token operator\">=</span> foreignKey<span class=\"token punctuation\">(</span><span class=\"token string\">\"link_FK\"</span><span class=\"token punctuation\">,</span> linkId<span class=\"token punctuation\">,</span> Links<span class=\"token punctuation\">)</span><span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Because domain models has slightly changed, we also have to redefine our data.</p>\n<Instruction>\n<p><code>databaseSetup</code> should be changed as in the following code:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">/**\n  * Load schema and populate sample data within this Sequence od DBActions\n  */</span>\n<span class=\"token keyword\">val</span> databaseSetup <span class=\"token operator\">=</span> DBIO<span class=\"token punctuation\">.</span>seq<span class=\"token punctuation\">(</span>\n  Users<span class=\"token punctuation\">.</span>schema<span class=\"token punctuation\">.</span>create<span class=\"token punctuation\">,</span>\n  Links<span class=\"token punctuation\">.</span>schema<span class=\"token punctuation\">.</span>create<span class=\"token punctuation\">,</span>\n  Votes<span class=\"token punctuation\">.</span>schema<span class=\"token punctuation\">.</span>create<span class=\"token punctuation\">,</span>\n\n  Users forceInsertAll Seq<span class=\"token punctuation\">(</span>\n    User<span class=\"token punctuation\">(</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"mario\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"mario@example.com\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"s3cr3t\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    User<span class=\"token punctuation\">(</span><span class=\"token number\">2</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"Fred\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"fred@flinstones.com\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"wilmalove\"</span><span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n\n  Links forceInsertAll Seq<span class=\"token punctuation\">(</span>\n    Link<span class=\"token punctuation\">(</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"http://howtographql.com\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"Awesome community driven GraphQL tutorial\"</span><span class=\"token punctuation\">,</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span> DateTime<span class=\"token punctuation\">(</span><span class=\"token number\">2017</span><span class=\"token punctuation\">,</span><span class=\"token number\">9</span><span class=\"token punctuation\">,</span><span class=\"token number\">12</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    Link<span class=\"token punctuation\">(</span><span class=\"token number\">2</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"http://graphql.org\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"Official GraphQL web page\"</span><span class=\"token punctuation\">,</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span> DateTime<span class=\"token punctuation\">(</span><span class=\"token number\">2017</span><span class=\"token punctuation\">,</span><span class=\"token number\">10</span><span class=\"token punctuation\">,</span><span class=\"token number\">1</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    Link<span class=\"token punctuation\">(</span><span class=\"token number\">3</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"https://facebook.github.io/graphql/\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"GraphQL specification\"</span><span class=\"token punctuation\">,</span><span class=\"token number\">2</span><span class=\"token punctuation\">,</span> DateTime<span class=\"token punctuation\">(</span><span class=\"token number\">2017</span><span class=\"token punctuation\">,</span><span class=\"token number\">10</span><span class=\"token punctuation\">,</span><span class=\"token number\">2</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n\n  Votes forceInsertAll Seq<span class=\"token punctuation\">(</span>\n    Vote<span class=\"token punctuation\">(</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token number\">1</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    Vote<span class=\"token punctuation\">(</span><span class=\"token number\">2</span><span class=\"token punctuation\">,</span> <span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token number\">2</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    Vote<span class=\"token punctuation\">(</span><span class=\"token number\">3</span><span class=\"token punctuation\">,</span> <span class=\"token number\">1</span><span class=\"token punctuation\">,</span> <span class=\"token number\">3</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    Vote<span class=\"token punctuation\">(</span><span class=\"token number\">4</span><span class=\"token punctuation\">,</span> <span class=\"token number\">2</span><span class=\"token punctuation\">,</span> <span class=\"token number\">2</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>I think we’re done with the Database part of changes. The following code represents the current state of <code>DBSchema</code> file:</p>\n<p><a href=\"https://gist.github.com/marioosh/033380591bc796c7b7b002f0860dfb79#file-dbschema-scala\">DBSchema.scala</a></p>\n<p>Now we can go and do the GraphQL part of changes.</p>\n<h3>Defining User->Link relation</h3>\n<p>Let’s begin with User-Link relation. In the first entity we have to add the field <code>links</code> and in the second the field <code>postedBy</code>.\nBoth fields uses the same Relation model.</p>\n<p>Actually a <code>Link</code> entity has to have two defined relations. First because we can lookup the database to find a link with a particular Id,\nSecond, when we want to filter links by user ids stored in <code>postedBy</code> column. Our Fetcher accepts the provided id already, so we have what covers the first case\nbut we still have to define the second one:</p>\n<Instruction>\n<p>In <code>GraphQLSchema</code> Add a relation to be able to find <code>Link</code>s by userId.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">//add to imports:</span>\n<span class=\"token keyword\">import</span> sangria<span class=\"token punctuation\">.</span>execution<span class=\"token punctuation\">.</span>deferred<span class=\"token punctuation\">.</span>Relation\n\n<span class=\"token comment\" spellcheck=\"true\">//place before fetchers definition</span>\n<span class=\"token keyword\">val</span> linkByUserRel <span class=\"token operator\">=</span> Relation<span class=\"token punctuation\">[</span>Link<span class=\"token punctuation\">,</span> <span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"byUser\"</span><span class=\"token punctuation\">,</span> l <span class=\"token keyword\">=></span> Seq<span class=\"token punctuation\">(</span>l<span class=\"token punctuation\">.</span>postedBy<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>This relation is of type <code>SimpleRelation</code> and has only two arguments: the first is the name, the second is a function which extracts a sequence of user ids from the link entity. Our case is super easy, because <code>postedBy</code> has such id. All we need to do is wrap it into the sequence.</p>\n<p>Now we have to add this relation to the fetcher. To do this, we have to use <code>Fetcher.rel</code> function instead of the previously used <code>apply</code></p>\n<Instruction>\n<p>Change <code>linksFetcher</code> to the following:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">//add to imports:</span>\n<span class=\"token keyword\">import</span> sangria<span class=\"token punctuation\">.</span>execution<span class=\"token punctuation\">.</span>deferred<span class=\"token punctuation\">.</span>RelationIds\n\n<span class=\"token comment\" spellcheck=\"true\">//replace the current `linksFetcher` declaration</span>\n<span class=\"token keyword\">val</span> linksFetcher <span class=\"token operator\">=</span> Fetcher<span class=\"token punctuation\">.</span>rel<span class=\"token punctuation\">(</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getLinks<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> RelationIds<span class=\"token punctuation\">[</span>Link<span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getLinksByUserIds<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">(</span>linkByUserRel<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>What do we have here? As I mentioned above, now we’re using <code>.rel</code> function. It needs the second function to be passed as the argument. This function is for fetching related data from a datasource. In our case it uses a function <code>getLinksByUserIds</code> that we have to add to our dao. <code>ids(linkByUserRel)</code> extracts user ids by the defined in relation way and passes it into the DAO function.</p>\n<Instruction>\n<p>In <code>DAO</code> class add a function:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">def</span> getLinksByUserIds<span class=\"token punctuation\">(</span>ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span><span class=\"token operator\">:</span> Future<span class=\"token punctuation\">[</span>Seq<span class=\"token punctuation\">[</span>Link<span class=\"token punctuation\">]</span><span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    db<span class=\"token punctuation\">.</span>run <span class=\"token punctuation\">{</span>\n      Links<span class=\"token punctuation\">.</span>filter<span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">.</span>postedBy inSet ids<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>result\n    <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Actually we’ve simplified the code above a little. When you look into the part <code>ctx.dao.getLinksByUserIds(ids(linkByUserRel))</code> a bit, you can wonder “And what if link has two relations? Could <code>getLinkByUserIds</code> be replaced by another function?” Be patient, such case will be covered later in this chapter.\nIn our case we have only one relation, so we can retrieve all <code>userId</code>’s by calling <code>ids(linkByUserRel)</code> functions.</p>\n<h3>Add fields to GraphQL Objects</h3>\n<p>Let’s begin with <code>LinkType</code>. <code>Link</code> already has a <code>postedBy</code> field, but for now it’s only an <code>Int</code> and we need the entire user.\nTo achieve this we have to replace the entire field definition and instruct resolver to use already defined fetcher to do this.</p>\n<Instruction>\n<p>Add <code>ReplaceField</code> type class to the <code>LinkType</code> constructor.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code>ReplaceField<span class=\"token punctuation\">(</span><span class=\"token string\">\"postedBy\"</span><span class=\"token punctuation\">,</span>\n      Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"postedBy\"</span><span class=\"token punctuation\">,</span> UserType<span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> usersFetcher<span class=\"token punctuation\">.</span>defer<span class=\"token punctuation\">(</span>c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>postedBy<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>In similar way we will change the <code>UserType</code> but <code>User</code> entity hasn’t <code>links</code> property so we have to add such field manually to the ObjectType.\n<code>AddField</code> type class is for such reason:</p>\n<Instruction>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code>AddFields<span class=\"token punctuation\">(</span>\n  Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"links\"</span><span class=\"token punctuation\">,</span> ListType<span class=\"token punctuation\">(</span>LinkType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> \n  resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span>  linksFetcher<span class=\"token punctuation\">.</span>deferRelSeq<span class=\"token punctuation\">(</span>linkByUserRel<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Now you can see that another fetcher function is being called. All <code>.deferRel...</code> functions needs two arguments instead of one. We have to add the relation object as the first argument, the second is a function which will get a mapping value from entity.</p>\n<p>We just added two relations to both <code>User</code> and <code>Link</code> object types. If you have tried to run this, you have probably experienced some issues. It’s because now we have a circular reference in the Object type declaration. There are two things we have to do to avoid this issue:</p>\n<Instruction>\n<p>Make <code>Link</code> and <code>User</code> lazy values. Additionally  all types explicitly if you haven’t done so yet:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">lazy</span> <span class=\"token keyword\">val</span> UserType<span class=\"token operator\">:</span> ObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> User<span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> deriveObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> User<span class=\"token punctuation\">]</span><span class=\"token comment\" spellcheck=\"true\">//...</span>\n\n<span class=\"token keyword\">lazy</span> <span class=\"token keyword\">val</span> LinkType<span class=\"token operator\">:</span> ObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Link<span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> deriveObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Link<span class=\"token punctuation\">]</span><span class=\"token comment\" spellcheck=\"true\">//...</span>\n</code></pre>\n      </div>\n<p>Wait, but why there is a <code>Unit</code> in type where should be a our context type? Because if we don’t use it explicitly inside field declaration (for example to get some\ndata stored in context) we can do it this way. In such case our object field fit any context, not only defined one.</p>\n</Instruction>\n<p>Now open the <code>graphiql</code> console in browser and try to execute this query: (tip: if the autocomplete doesn’t work for the new fields, try to refresh a page)</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"false\"><code><span class=\"token keyword\">query</span> <span class=\"token punctuation\">{</span>\n  link<span class=\"token punctuation\">(</span><span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> <span class=\"token number\">1</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">{</span>\n    id\n    url\n    createdAt\n    postedBy <span class=\"token punctuation\">{</span>\n      name\n      links <span class=\"token punctuation\">{</span>\n        id\n        url\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>As you can see, both relations work perfectly.</p>\n<p>Time to add the rest of them.</p>\n<h3>Vote - User Relation</h3>\n<p>Before I go further, try to do it yourself. All steps you need to do, are similar to the those we have already done.</p>\n<p>To be honest, half of work you have already done :D There is <code>userId</code> field in the <code>Vote</code> model. Database is also prepared, there is not much work to do here.</p>\n<p>Ok. Let’s begin from proper database function.</p>\n<Instruction>\n<p>In <code>DAO</code> class add following function:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">def</span> getVotesByUserIds<span class=\"token punctuation\">(</span>ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span><span class=\"token operator\">:</span> Future<span class=\"token punctuation\">[</span>Seq<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n    db<span class=\"token punctuation\">.</span>run <span class=\"token punctuation\">{</span>\n      Votes<span class=\"token punctuation\">.</span>filter<span class=\"token punctuation\">(</span>_<span class=\"token punctuation\">.</span>userId inSet ids<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>result\n    <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>The rest of the changes will be applied in the <code>GraphQLSchema</code> file.</p>\n<Instruction>\n<p>Add a relation between <code>Vote</code> and <code>User</code></p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">val</span> voteByUserRel <span class=\"token operator\">=</span> Relation<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">,</span> <span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"byUser\"</span><span class=\"token punctuation\">,</span> v <span class=\"token keyword\">=></span> Seq<span class=\"token punctuation\">(</span>v<span class=\"token punctuation\">.</span>userId<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Don’t forget in <code>Relation</code> we always have to return a sequence!\nAlso we have to change the fetcher definition.</p>\n<Instruction>\n<p>Change the <code>votesFetcher</code> definition with the following:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">val</span> votesFetcher <span class=\"token operator\">=</span> Fetcher<span class=\"token punctuation\">.</span>rel<span class=\"token punctuation\">(</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getVotes<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> RelationIds<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getVotesByUserIds<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">(</span>voteByUserRel<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Change <code>UserType</code>:</p>\n<Instruction>\n<p>Inside <code>AddField</code> type class, add a new field:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code>Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"votes\"</span><span class=\"token punctuation\">,</span> ListType<span class=\"token punctuation\">(</span>VoteType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span>  votesFetcher<span class=\"token punctuation\">.</span>deferRelSeq<span class=\"token punctuation\">(</span>voteByUserRel<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Also modify the defined <code>VoteType</code>:</p>\n<Instruction>\n<p>Replace <code>VoteType</code> with the following code:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">lazy</span> <span class=\"token keyword\">val</span> VoteType<span class=\"token operator\">:</span> ObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Vote<span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> deriveObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span>\n    Interfaces<span class=\"token punctuation\">(</span>IdentifiableType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    ExcludeFields<span class=\"token punctuation\">(</span><span class=\"token string\">\"userId\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    AddFields<span class=\"token punctuation\">(</span>Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"user\"</span><span class=\"token punctuation\">,</span>  UserType<span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> usersFetcher<span class=\"token punctuation\">.</span>defer<span class=\"token punctuation\">(</span>c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>userId<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>That’s all. After this changes you should be able to execute the query like this:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"   nocopy=\"undefined\"><code>query {\n  link(id: 1){\n    id\n    url\n    createdAt\n    postedBy {\n      name\n      links {\n        id\n        url\n      }\n      votes {\n        id\n        user {\n          name\n        }\n      }\n    }\n  }\n}</code></pre>\n      </div>\n<p>As you can see we can ask for users who vote for links posted by the author of the current link. Simple like that.</p>\n<h3>Vote - Link Relation</h3>\n<p>One relation is still missing in our example. In my opinion you have enough knowledge to try and write it yourself.\nAfter that I’ll do it step by step. Reminder: case classes and database setup support this relation, you do not need to change anything there.</p>\n<p>Lets start from defining relation object:</p>\n<Instruction>\n<p>Add <code>voteByLinkRel</code> constant to the <code>GraphQLSchema</code> file.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">val</span> voteByLinkRel <span class=\"token operator\">=</span> Relation<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">,</span> <span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"byLink\"</span><span class=\"token punctuation\">,</span> v <span class=\"token keyword\">=></span> Seq<span class=\"token punctuation\">(</span>v<span class=\"token punctuation\">.</span>linkId<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Now we can add the <code>votes</code> field to the <code>LinkType</code>.</p>\n<Instruction>\n<p>Add the following code after the existing <code>ReplaceField</code>.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code>AddFields<span class=\"token punctuation\">(</span>\n      Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"votes\"</span><span class=\"token punctuation\">,</span> ListType<span class=\"token punctuation\">(</span>VoteType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> votesFetcher<span class=\"token punctuation\">.</span>deferRelSeq<span class=\"token punctuation\">(</span>voteByLinkRel<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>You see the similarities between both <code>votes</code> fields, don’t you? </p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">//UserType</span>\nField<span class=\"token punctuation\">(</span><span class=\"token string\">\"votes\"</span><span class=\"token punctuation\">,</span> ListType<span class=\"token punctuation\">(</span>VoteType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> votesFetcher<span class=\"token punctuation\">.</span>deferRelSeq<span class=\"token punctuation\">(</span>voteByUserRel<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n\n<span class=\"token comment\" spellcheck=\"true\">//LinkType</span>\nField<span class=\"token punctuation\">(</span><span class=\"token string\">\"votes\"</span><span class=\"token punctuation\">,</span> ListType<span class=\"token punctuation\">(</span>VoteType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> votesFetcher<span class=\"token punctuation\">.</span>deferRelSeq<span class=\"token punctuation\">(</span>voteByLinkRel<span class=\"token punctuation\">,</span> c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>id<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n<p>Both are almost the same, the only difference is the type of <code>Relation</code> we’re using as the first argument.\nActually in this way you can add any relation you want.</p>\n<p>Now you should be able to query for this field.</p>\n<hr>\n<p>The second part won’t be as easy.</p>\n<p>Please look at the existing <code>votesFetcher</code> definition:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">val</span> votesFetcher <span class=\"token operator\">=</span> Fetcher<span class=\"token punctuation\">.</span>rel<span class=\"token punctuation\">(</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getVotes<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> RelationIds<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getVotesByUserIds<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">(</span>voteByUserRel<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n<p>The first function fetches votes by their id. Nothing to comment here.\nThe second function, on the other hand, fetches votes by relation. Actually by <code>voteByUserRel</code> relation.\nThere is no fetcher API that supports more than one relation function, so we have to refactor it a little bit.</p>\n<p>In our case, we want to fetch votes by any relation, either with <code>User</code> or with <code>Link</code>.</p>\n<p><code>ids(voteByUserRel)</code> extracts the users’ ids and passes those to the db function,\nwe have to change it. It is a  good idea to pass <code>ids</code> down to the function, and in <code>DAO</code> decide which field it should use to filter.</p>\n<Instruction>\n<p>Replace the second function of <code>votesFetcher</code> with the following one:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token punctuation\">(</span>ctx<span class=\"token operator\">:</span> MyContext<span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> RelationIds<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> ctx<span class=\"token punctuation\">.</span>dao<span class=\"token punctuation\">.</span>getVotesByRelationIds<span class=\"token punctuation\">(</span>ids<span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>There is one missing part: <code>DAO.getVotesByRelationIds</code> function, let’s create it now. This function should match the kind of relation we’re asking for, and filter by field depends on that relation.</p>\n<Instruction>\n<p>To the <code>DAO</code> file add <code>getVotesByRelationIds</code> function with code:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">//add to imports:</span>\n<span class=\"token keyword\">import</span> sangria<span class=\"token punctuation\">.</span>execution<span class=\"token punctuation\">.</span>deferred<span class=\"token punctuation\">.</span><span class=\"token punctuation\">{</span>RelationIds<span class=\"token punctuation\">,</span> SimpleRelation<span class=\"token punctuation\">}</span>\n\n<span class=\"token comment\" spellcheck=\"true\">//add in body</span>\n<span class=\"token keyword\">def</span> getVotesByRelationIds<span class=\"token punctuation\">(</span>rel<span class=\"token operator\">:</span> RelationIds<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span><span class=\"token operator\">:</span> Future<span class=\"token punctuation\">[</span>Seq<span class=\"token punctuation\">[</span>Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span>\n  db<span class=\"token punctuation\">.</span>run<span class=\"token punctuation\">(</span>\n    Votes<span class=\"token punctuation\">.</span>filter <span class=\"token punctuation\">{</span> vote <span class=\"token keyword\">=></span>\n      rel<span class=\"token punctuation\">.</span>rawIds<span class=\"token punctuation\">.</span>collect<span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">case</span> <span class=\"token punctuation\">(</span>SimpleRelation<span class=\"token punctuation\">(</span><span class=\"token string\">\"byUser\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> vote<span class=\"token punctuation\">.</span>userId inSet ids\n        <span class=\"token keyword\">case</span> <span class=\"token punctuation\">(</span>SimpleRelation<span class=\"token punctuation\">(</span><span class=\"token string\">\"byLink\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> ids<span class=\"token operator\">:</span> Seq<span class=\"token punctuation\">[</span><span class=\"token builtin\">Int</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span> <span class=\"token keyword\">=></span> vote<span class=\"token punctuation\">.</span>linkId inSet ids\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>foldLeft<span class=\"token punctuation\">(</span><span class=\"token boolean\">true</span><span class=\"token operator\">:</span> Rep<span class=\"token punctuation\">[</span><span class=\"token builtin\">Boolean</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">(</span>_ <span class=\"token operator\">||</span> _<span class=\"token punctuation\">)</span>\n\n    <span class=\"token punctuation\">}</span> result\n  <span class=\"token punctuation\">)</span>\n</code></pre>\n      </div>\n<p>The function above use pattern matching to recognize which type of relation it has and depending on that relation uses the proper filter.</p>\n</Instruction>\n<p>The last thing to do is to change <code>VoteType</code> definition. We have to remove <code>linkId</code> property and instead add <code>link</code> field which returns\nthe entire <code>Link</code> object.</p>\n<Instruction>\n<p>Replace current <code>VoteType</code> declaration with the following one:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-scala\"   nocopy=\"false\"><code><span class=\"token keyword\">lazy</span> <span class=\"token keyword\">val</span> VoteType<span class=\"token operator\">:</span> ObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Vote<span class=\"token punctuation\">]</span> <span class=\"token operator\">=</span> deriveObjectType<span class=\"token punctuation\">[</span><span class=\"token builtin\">Unit</span><span class=\"token punctuation\">,</span> Vote<span class=\"token punctuation\">]</span><span class=\"token punctuation\">(</span>\n    Interfaces<span class=\"token punctuation\">(</span>IdentifiableType<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    ExcludeFields<span class=\"token punctuation\">(</span><span class=\"token string\">\"userId\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"linkId\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    AddFields<span class=\"token punctuation\">(</span>Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"user\"</span><span class=\"token punctuation\">,</span>  UserType<span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> usersFetcher<span class=\"token punctuation\">.</span>defer<span class=\"token punctuation\">(</span>c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>userId<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span>\n    AddFields<span class=\"token punctuation\">(</span>Field<span class=\"token punctuation\">(</span><span class=\"token string\">\"link\"</span><span class=\"token punctuation\">,</span>  LinkType<span class=\"token punctuation\">,</span> resolve <span class=\"token operator\">=</span> c <span class=\"token keyword\">=></span> linksFetcher<span class=\"token punctuation\">.</span>defer<span class=\"token punctuation\">(</span>c<span class=\"token punctuation\">.</span>value<span class=\"token punctuation\">.</span>linkId<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span>\n  <span class=\"token punctuation\">)</span>\n    \n</code></pre>\n      </div>\n</Instruction>\n<p>Now you’re ready to execute a query like that:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"false\"><code><span class=\"token keyword\">query</span> <span class=\"token punctuation\">{</span>\n  links<span class=\"token punctuation\">(</span><span class=\"token attr-name\">ids</span> <span class=\"token punctuation\">:</span><span class=\"token punctuation\">[</span><span class=\"token number\">1</span><span class=\"token punctuation\">,</span><span class=\"token number\">2</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">{</span>\n    url\n    votes <span class=\"token punctuation\">{</span>\n      user<span class=\"token punctuation\">{</span>\n        name\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>You can also delete <code>DAO.getVotesByUserIds</code> function, we won’t need it anymore.</p>\n<h3>Recap</h3>\n<p>We achieved our goal for this chapter, our models have new functions:</p>\n<p><code>User</code> has <code>links</code> and <code>votes</code> fields.<br>\n<code>Link</code> has <code>postedBy</code> and <code>votes</code> fields.<br>\n<code>Vote</code> has <code>user</code> and <code>link</code> fields.  </p>\n<p>Now we can fetch the related data…</p>\n<p>The current state of fileds we’ve changed in this chapter you can compare with those gists:</p>\n<p><a href=\"https://gist.github.com/marioosh/7c3ee5fed1238c5daf89a4459727f575#file-dao-scala\">DAO.scala</a><br>\n<a href=\"https://gist.github.com/marioosh/7c3ee5fed1238c5daf89a4459727f575#file-models_package-scala\">models/package.scala</a><br>\n<a href=\"https://gist.github.com/marioosh/7c3ee5fed1238c5daf89a4459727f575#file-dbschema-scala\">DBSchema.scala</a><br>\n<a href=\"https://gist.github.com/marioosh/7c3ee5fed1238c5daf89a4459727f575#file-graphqlschema-scala\">GraphQLSchema.scala</a>  </p>\n<p>In the next chapter you will learn how to add and save entities with GraphQL mutations.</p>",
				"fields": {
					"slug": "/graphql-scala/7-relations/"
				},
				"excerpt": "Relations define how entities are connected with one another. You probably encountered those while working with databases. \nIn GraphQL (and...",
				"frontmatter": {
					"title": "Relations",
					"videoId": null,
					"videoAuthor": null,
					"parent": "/opt/build/repo/content/backend/graphql-scala/7-relations.md absPath of file",
					"question": "Are we limited to amount of defined relations per model?",
					"answers": [
						"Yes, 1 per model",
						"Yes, 2 per model",
						"No, there is no such limitation",
						"No, but relation could be based only on models's id"
					],
					"correctAnswer": 2,
					"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities.",
					"pageTitle": "GraphQL Scala - Relations"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-elixir/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-elixir/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-elixir/4-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-js/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Server and Database with the Prisma Client",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-js/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Building a Server with GraphQL and Graphene"
							},
							"fields": {
								"slug": "/graphql-python/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Setting up a Django Graphene Project"
							},
							"fields": {
								"slug": "/graphql-python/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Tutorial Summary"
							},
							"fields": {
								"slug": "/graphql-python/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Creating Data With Mutations"
							},
							"fields": {
								"slug": "/graphql-python/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Creating Your First Queries"
							},
							"fields": {
								"slug": "/graphql-python/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Authenticating on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Links and Voting",
								"description": "Enable Users to create Links and to Vote on them"
							},
							"fields": {
								"slug": "/graphql-python/5-links-and-voting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Handling Errors on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Filtering GraphQL Queries"
							},
							"fields": {
								"slug": "/graphql-python/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Simple Pagination with Graphene"
							},
							"fields": {
								"slug": "/graphql-python/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relay",
								"description": "Using Relay on Graphene"
							},
							"fields": {
								"slug": "/graphql-python/9-relay/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-java/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
							},
							"fields": {
								"slug": "/graphql-java/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/10-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Alternative approaches to schema development",
								"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
							},
							"fields": {
								"slug": "/graphql-java/11-alternative-approaches/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-java/12-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connectors",
								"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/4-connectors/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
							},
							"fields": {
								"slug": "/graphql-java/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/6-more-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Subscriptions",
								"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-java/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
							},
							"fields": {
								"slug": "/graphql-java/7-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/9-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-ruby/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-ruby/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
							},
							"fields": {
								"slug": "/graphql-ruby/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Nodes",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/5-connecting-nodes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/graphql-scala/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
							},
							"fields": {
								"slug": "/graphql-scala/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-ruby/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "The first query",
								"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
							},
							"fields": {
								"slug": "/graphql-scala/2-preparing-first-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Handling Arguments",
								"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
							},
							"fields": {
								"slug": "/graphql-scala/3-handling_arguments/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Custom Scalars",
								"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
							},
							"fields": {
								"slug": "/graphql-scala/5-custom_scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deferred Resolvers",
								"description": "In this chapter you will learn how to improve performance with deferred resolvers."
							},
							"fields": {
								"slug": "/graphql-scala/4-deferred_resolvers/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Interfaces",
								"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
							},
							"fields": {
								"slug": "/graphql-scala/6-interfaces/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relations",
								"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
							},
							"fields": {
								"slug": "/graphql-scala/7-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "In this chapter you will learn how to add data to the database."
							},
							"fields": {
								"slug": "/graphql-scala/8-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
							},
							"fields": {
								"slug": "/graphql-scala/9-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/angular-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/angular-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading link-items",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
							},
							"fields": {
								"slug": "/angular-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
							},
							"fields": {
								"slug": "/angular-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/angular-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, React & Apollo Client. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
							},
							"fields": {
								"slug": "/react-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/angular-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Apollo Client you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
							},
							"fields": {
								"slug": "/react-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
							},
							"fields": {
								"slug": "/react-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use react-router 4 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
							},
							"fields": {
								"slug": "/react-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/react-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/react-relay/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-relay/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
							},
							"fields": {
								"slug": "/react-relay/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": null
							},
							"fields": {
								"slug": "/react-relay/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-relay/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
							},
							"fields": {
								"slug": "/react-relay/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
							},
							"fields": {
								"slug": "/react-relay/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Clients",
								"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
							},
							"fields": {
								"slug": "/advanced/0-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More GraphQL Concepts",
								"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
							},
							"fields": {
								"slug": "/advanced/2-more-graphql-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Server",
								"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
							},
							"fields": {
								"slug": "/advanced/1-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Tooling and Ecosystem",
								"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
							},
							"fields": {
								"slug": "/advanced/3-tooling-and-ecosystem/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Security",
								"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
							},
							"fields": {
								"slug": "/advanced/4-security/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
							},
							"fields": {
								"slug": "/advanced/5-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/vue-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
							},
							"fields": {
								"slug": "/vue-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
							},
							"fields": {
								"slug": "/vue-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/vue-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/vue-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GraphQL is the better REST",
								"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
							},
							"fields": {
								"slug": "/basics/1-graphql-is-the-better-rest/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Core Concepts",
								"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL. Try them out in your own sandbox."
							},
							"fields": {
								"slug": "/basics/2-core-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/ember-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Architecture)",
								"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/ember-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigation",
								"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/4-navigation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
							},
							"fields": {
								"slug": "/ember-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/8-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/vue-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/5-authentication/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/graphql-scala/7-relations/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---graphql-scala-7-relations-b0f849b6c74ef68379b5.js